
/**
 * 응답 데이터
 * @nullable
 */
export type GetDashboardPaymentMethods200Data = { [key: string]: unknown } | null;
